/**
 * Sheet — 底部抽屉
 *
 * 默认移动端可用（md:hidden）。
 * 设 desktopVisible=true 时桌面端以居中弹窗显示。
 */

import { ReactNode, useEffect } from 'react';

export interface SheetProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  /** 桌面端是否可见（false=仅移动端，true=所有端，桌面端居中弹窗） */
  desktopVisible?: boolean;
}

export function Sheet({ open, onClose, children, desktopVisible = false }: SheetProps) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  if (desktopVisible) {
    // 桌面端居中弹窗
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div className="absolute inset-0 bg-charcoal/30 backdrop-blur-sm" onClick={onClose} />
        <div className="relative w-full max-w-lg mx-4 bg-white dark:bg-warm-dark rounded-xl shadow-lg max-h-[70vh] overflow-y-auto">
          {children}
        </div>
      </div>
    );
  }

  // 移动端底部抽屉
  return (
    <div className="fixed inset-0 z-40 md:hidden">
      <div className="absolute inset-0 bg-charcoal/30 backdrop-blur-sm" onClick={onClose} />
      <div className="absolute bottom-0 left-0 right-0 bg-white dark:bg-warm-dark rounded-t-xl shadow-lg max-h-[70vh] overflow-y-auto pb-[env(safe-area-inset-bottom)]">
        <div className="flex justify-center pt-2 pb-1">
          <div className="w-10 h-1 rounded-full bg-border-warm dark:bg-border-warm-dark" />
        </div>
        {children}
      </div>
    </div>
  );
}
